export default __webpack_public_path__ + "static/media/setsruin.e1c63ef1.png";